export const ACCOUNT_VALIDATION_RULES = {
  "accountRecievables.generalRecievableAccount": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountRecievables.insuranceTaxRecievable": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountRecievables.gst": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountRecievables.hst": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountRecievables.qst": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountRecievables.bonusToRecieve": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountRecievables.commissionAdvances": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.generalPayableAccount": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.customerReservations": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.insuranceTaxPayable": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.gstToPay": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.qstToPay": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.hstToPay": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.commissionIncome": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.freshIncome": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.increasedIncome": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.bonusToPay": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.brokerCommission": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.salesTaxMarkupPayable": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.gstMarkUp": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.qstMarkUp": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountPayables.hstMarkUp": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
  "accountBusinessUnits.businessUnitAccount": {
    isRequiredTrim: {
      value: true,
    },
    maxLength: {
      value: 7,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/accounts/accountValidationRules.js